/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeletedUserDto { 
    type: DeletedUserDto.TypeEnum;
    id: string;
    email?: string;
    deletedAt?: string;
}
export namespace DeletedUserDto {
    export const TypeEnum = {
        deleted: 'deleted'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


